// Next-job rows sourced from a user's searches. 'search' is the current source type;
// 'job_search_alert' is the legacy value retained on rows not yet re-synced.
export const isSearchSourcedRow = (sourceType: string | undefined): boolean =>
  sourceType === 'search' || sourceType === 'job_search_alert';
